export const myName = "Shuhei Watanabe"
// NOTE: This order is preserved in the website as well.
export const availableVenueTypes: VenueType[] = [
  "Conference",
  "Journal",
  "Talk",
  "Workshop",
  "Preprint",
  "Thesis",
  "Notebook",
]
